import * as React from 'react';
import { useState, useEffect } from 'react';
import { Link, Link as RouterLink } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';
import StepContent from '@material-ui/core/StepContent';
import Button from '@material-ui/core/Button';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import { Container } from '@material-ui/core';


import LevelCard from 'src/materials/LevelCard';
import Steps from 'src/utils/sampleData.json';

//Redux
import { useSelector } from "react-redux";




const useStyles = makeStyles((theme) => ({
  root: {
    maxWidth: 400,
    margin: 'auto',
    // overflow: 'scroll'
  },
  button: {
    marginTop: theme.spacing(1),
    marginRight: theme.spacing(1),
  },
  actionsContainer: {
    marginBottom: theme.spacing(2),
  },
  resetContainer: {
    padding: theme.spacing(3),
  },
}));



export default function VerticalLinearStepper() {
  const classes = useStyles();
  const { user } = useSelector(state => state.auth);
  const [activeStep, setActiveStep] = useState(0);

  const handleNext = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };


  useEffect(() => {
    if(user && user.status){
        console.log(user.status)
        let stat = user.status;
        setActiveStep(stat.reloanCounts - 1);
    }
  }, [user])

  return (
    <div className={classes.root}>
      <Container>
      <Stepper activeStep={activeStep} orientation="vertical">
            {}
        {Steps.terms.map((step, index) => {

            return(
          <Step key={index}>
            <StepLabel
              optional={
                 <LevelCard key={index} data={step}/>
              }
            >
             {activeStep === index ? 'Current Credit Terms' : activeStep > index ? 'Recent Terms' : 'Next Credit Terms'}
            </StepLabel>
            <StepContent className="center-element">
                  <Button
                    variant="contained"
                    onClick={handleNext}
                    component={RouterLink}
                    to="/app/applications?loan"
                    className={classes.button}
                  >
                      Apply Loan
                  </Button>
               
            </StepContent>
          </Step>
        )})}
      </Stepper>
      {/* {activeStep === steps.length && (
        <Paper square elevation={0} className={classes.resetContainer}>
          <Typography>All steps completed - you&apos;re finished</Typography>
          <Button onClick={handleReset} className={classes.button}>
            Reset
          </Button>
        </Paper>
      )} */}
      </Container>
    </div>
  );
}
